import { WelfareAppId } from '../../const/welfareAppId';

class JSAPI {
  refreshToken(uin, succCallback, errorCallback) {
    console.log('ready refreshToken');
    if (window.browser && window.browser.login && window.browser.login.refreshToken) {
      window.browser.login.refreshToken({
        uin,
        appID: '116',
      }, (rst) => {
        console.log(`refreshToken succ: ${rst}`);
        succCallback && succCallback(rst || {});
      });
    } else {
      console.log('refreshToken error: browser.login.refreshToken Not Exist!');
      errorCallback && errorCallback();
    }
  }
  /**
   * @desc 注册浏览器push
   *
   * @memberof JSAPI
   */
  QBPushRegister(qbid = '') {
    console.log('QBPushRegister qbid', qbid);
    if (window.browser && window.browser.app && window.browser.app.doTokenFeature) {
      console.log('do QBPushRegister');
      window.browser.app.doTokenFeature((rst) => {
        console.log('QBPushRegister', rst);
      }, {
        uid: qbid,
      });
    } else {
      console.log('QBPushRegister not exists');
    }
  }
  /**
   * @desc 获取浏览器提供的参数，qua2
   */
  getQua2() {
    console.log('getQua2 enter');
    return new Promise((resolve) => {
      if (window.browser && window.browser.app && window.browser.app.getQua2) {
        window.browser.app.getQua2(qua => resolve(qua), () => resolve(''));
      } else {
        return resolve('');
      }
    });
  }

  /**
   * @desc 判断是否为独立端
   */
  getTerminalIsQBFF(qua) {
    return qua.includes('PR=SME') || qua.includes('PR=SR');
  }

  /**
   * @desc 通过qua2获取到传递给福利后台的应用id
   *
   * @memberof SecurityService
   */
  getAppidByQua(qua) {
    if (!qua) throw new Error('qua missed');

    if (qua.includes('PR=SR')) {
      return WelfareAppId.QBNOVEL;
    }

    if (qua.includes('PR=SME')) {
      return WelfareAppId.QBFF;
    }

    return WelfareAppId.QB;
  }

  logoutAuthorizeInfo(succCallback, errorCallback) {
    console.log('ready logoutAuthorizeInfo');
    if (window.browser && window.browser.logoutAuthorizeInfo) {
      window.browser.logoutAuthorizeInfo((rst) => {
        console.log(`logoutAuthorizeInfo succ: ${rst}`);
        succCallback && succCallback(rst || {});
      }, (rst) => {
        console.log(`logoutAuthorizeInfo fail: ${rst}`);
        errorCallback && errorCallback(rst || {});
      }, {
        appID: '116',
      });
    } else {
      console.log('logoutAuthorizeInfo error: browser.logoutAuthorizeInfo Not Exist!');
      errorCallback && errorCallback();
    }
  }
}

export default new JSAPI();
